import React from 'react';

const IconComment = ({ size = 13, color = "#0062FF" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.42334 6.42407C1.42334 5.02735 1.97819 3.68783 2.96582 2.7002C3.95345 1.71256 5.29297 1.15771 6.6897 1.15771C8.08642 1.15771 9.42594 1.71256 10.4136 2.7002C11.4012 3.68783 11.9561 5.02735 11.9561 6.42407V9.77479C11.9561 10.333 11.9561 10.6108 11.8731 10.834C11.8072 11.0108 11.704 11.1714 11.5705 11.3049C11.437 11.4383 11.2764 11.5415 11.0996 11.6075C10.8765 11.6904 10.598 11.6904 10.0404 11.6904H6.6897C5.29297 11.6904 3.95345 11.1356 2.96582 10.1479C1.97819 9.16032 1.42334 7.8208 1.42334 6.42407Z" stroke={color} strokeWidth="1.5" />
      <path d="M4.71484 5.76562H8.66461M6.68973 8.3988H8.66461" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default IconComment; 